var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',[_c('v-overlay',{attrs:{"opacity":"0.8","z-index":"10"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }